/* eslint-disable */
import * as Yup from 'yup';
import { useState, useEffect } from 'react';
// material
import {
    Container, Card
} from '@material-ui/core';
import { useFormik, Form, FormikProvider } from 'formik';
import { Stack, TextField, IconButton, Button, Box, InputAdornment, Tooltip, Grid } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import Divider from '@material-ui/core/Divider';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import EditIcon from '@material-ui/icons/Edit';
import { AESEncryptionParam } from '../../../../helpers/AesEncrypt';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Page from '../../../Page';
import SearchNotFound from '../../../SearchNotFound';
import Service from '../Service';
import Chip from '@material-ui/core/Chip';
import permissionAuth from 'src/utils/permissionAuth';
import TokenDecoder from 'src/helpers/TokenDecoder';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import PropTypes, { func } from 'prop-types'
import { useTheme } from '@mui/material/styles'
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import { AlertDialog } from './../../Common/AlertDialog';
function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

export default function CustomerOrderPanelListing(props) {
    const screenCode = 'CUSTOMERORDERPANEL';
    let encrypted = "";
    const navigate = useNavigate();
    const [date, setDate] = useState(new Date());
    const [formData, setFormData] = useState({
        groupID: "0",
        operationEntityID: "0",
        dataID: date.toISOString().split('T')[0]
    });
    const [groupList, setGroupList] = useState([]);
    const [outletList, setOutletList] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });

    const [approveVPUSpecialOrderDetails, setApproveVPUSpecialOrderDetails] = useState();
    const [rejectVPUSpecialOrderDetails, setRejectVPUSpecialOrderDetails] = useState();
    const [message, setMessage] = useState("Special Order Approve Confirmation");
    const [message2, setMessage2] = useState("Special Order Reject Confirmation");
    const [EnableConfirmMessage, setEnableConfirmMessage] = useState(false);
    const [EnableConfirmMessage2, setEnableConfirmMessage2] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [renderSearchForm, setRenderSearchForm] = useState(true);
    const [specialOrders, setSpecialOrders] = useState([]);
    const [specialOrderCreated, setSpecialOrderCreated] = useState(false);

    const customerOrderPanelListingSchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please Select Group').required('Group Required'),
        operationEntityID: Yup.number(),
        dateID: Yup.date().min(1, 'Please Select Date').required('Date required')
    });

    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            operationEntityID: formData.operationEntityID,
            dateID: formData.dataID
        },
        validationSchema: customerOrderPanelListingSchema,
        onSubmit: (values) => {
            trackPromise(GetCustomerOrderDetailsForListing(values))
        }
    });

    const { errors, setValues, touched, handleSubmit, isSubmitting, getFieldProps, values } = formik;

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - tableData.length) : 0;

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };



    useEffect(() => {
        const storedFormData = JSON.parse(sessionStorage.getItem('customerOrderPanelFormData'));
        const storedPage = JSON.parse(sessionStorage.getItem('customerOrderPanelPage'));
        getPermissions(storedFormData, storedPage);
        sessionStorage.removeItem('customerOrderPanelFormData');
        sessionStorage.removeItem('customerOrderPanelPage');
    }, []);

    useEffect(() => {
        if (specialOrderCreated) {
            GetSpecialOrdersByVccDate();
        }
    }, [specialOrderCreated]);

    async function getPermissions(storedFormData, storedPage) {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWCUSTOMERORDERPANEL');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find((p) => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find((p) => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined
        });

        const isInitialLoading = storedFormData === null
        if (isInitialLoading) {
            setValues({
                ...values,
                groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
                operationEntityID: parseInt(TokenDecoder.getGroupFactoryToken().factory)
            })
        } else {
            setValues({
                ...values,
                groupID: parseInt(storedFormData.groupID),
                operationEntityID: parseInt(storedFormData.operationEntityID),
                dateID: storedFormData.dateID
            })
            trackPromise(GetCustomerOrderDetailsForListing(storedFormData));
            if (storedPage !== null) {
                setPage(storedPage);
            }
        }
        trackPromise(GetAllGroups());
    }

    useEffect(() => {
        trackPromise(GetOperationEntityByGroupID());
    }, [formik.values.groupID]);

    useEffect(() => {
        setTableData([]);
        setIsLoading(false);
        setRenderSearchForm(false);
    }, [formik.values.operationEntityID, formik.values.dateID]);

    async function GetAllGroups() {
        var res = await Service.GetAllGroupsForDropDown();
        if (res != null) {
            setGroupList(res);
        }
    }

    async function GetOperationEntityByGroupID() {
        var res = await Service.GetKfcOutletsByGroupID(formik.values.groupID);
        if (res != null) {
            setOutletList(res);
        }
    }

    const handleSpecialOrderCreated = () => {
        setSpecialOrderCreated(true);
    };


    async function clearAll() {
        setTableData([]);
        setPage(0);
        sessionStorage.removeItem('customerOrderPanelFormData');
        sessionStorage.removeItem('customerOrderPanelPage');
    }

    function handleClick(data) {
        setPage(0);
        sessionStorage.setItem('customerOrderPanelFormData', JSON.stringify(values));
        sessionStorage.setItem('customerOrderPanelPage', JSON.stringify(page));
        encrypted = AESEncryptionParam(data.customerOrderID.toString());
        navigate('/dashboard/CustomerOrderPanel/AddEdit/' + encrypted)
    }

    async function GetCustomerOrderDetailsForListing(values) {
        let model = {
            groupID: parseInt(values.groupID),
            outletID: parseInt(values.operationEntityID),
            orderDate: values.dateID
        }
        var res = await Service.GetCustomerOrderDetailsForListing(model);
        if (res != null) {
            setTableData(res);
        }
    }

    async function ApproveVPUSpecialOrder(value) {
        let model = {
            specialOrderID: parseInt(value.specialOrderID),
            modifiedBy: parseInt(TokenDecoder.getUserIDFromToken())
        }
        var res = await Service.ApproveVPUSpecialOrder(model);
        if (res.statusCode === "Success") {
            toast.success(res.message);
        } else {
            toast.error(res.message);
        }
    }

    async function RejectVPUSpecialOrder(value) {
        let model = {
            specialOrderID: parseInt(value.specialOrderID),
            modifiedBy: parseInt(TokenDecoder.getUserIDFromToken())
        }
        var res = await Service.RejectVPUSpecialOrder(model);
        if (res.statusCode === "Success") {
            toast.success(res.message);
        } else {
            toast.error(res.message);
        }
    }

    async function ApproveVPUSpecialOrderPopUp(data) {
        setEnableConfirmMessage(true);
        setApproveVPUSpecialOrderDetails(data)
    }

    async function RejectVPUSpecialOrderPopUp(data) {
        setEnableConfirmMessage2(true);
        setRejectVPUSpecialOrderDetails(data)
    }

    function confirmData(y) {
        if (y) {
            ApproveVPUSpecialOrder(approveVPUSpecialOrderDetails);
        }
    }

    function confirmData2(y) {
        if (y) {
            RejectVPUSpecialOrder(rejectVPUSpecialOrderDetails);
        }
    }

    return (
        <>
            <Page title="Customer Order Panel |  FAPS">
                <Container>
                    <CommonPageHeader
                        path={"/dashboard/CustomerOrderPanel/AddEdit/" + AESEncryptionParam("0")}
                        btname="Add"
                        pageName="Customer Order Panel"
                    />
                    <FormikProvider value={formik}>
                        <ToastContainer
                            position="bottom-right"
                            pauseOnHover
                        />
                        <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                            <Stack spacing={4}>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Group *"
                                        value={formik.values.groupID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('groupID')}
                                        error={Boolean(touched.groupID && errors.groupID)}
                                        helperText={touched.groupID && errors.groupID}
                                        InputProps={{
                                            readOnly: !permissionList.isGroupFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}> Select Group</MenuItem>
                                        {groupList.map((option) => (
                                            option.isActive == true ? <MenuItem key={option.groupID} value={option.groupID}>
                                                {option.groupName}
                                            </MenuItem> : null
                                        ))}
                                    </TextField>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Outlet"
                                        value={formik.values.operationEntityID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('operationEntityID')}
                                        error={Boolean(touched.operationEntityID && errors.operationEntityID)}
                                        helperText={touched.operationEntityID && errors.operationEntityID}
                                        InputProps={{
                                            readOnly: !permissionList.isFactoryFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}> All Outlets</MenuItem>
                                        {outletList.map((option) => (
                                            <MenuItem key={option.factoryID} value={option.factoryID}>
                                                {option.factoryName}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                    <TextField
                                        fullWidth
                                        id="outlined-start-adornment"
                                        size="small"
                                        label="Date *"
                                        type="Date"
                                        value={formik.values.dateID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('dateID')}
                                        error={Boolean(touched.dateID && errors.dateID)}
                                        helperText={touched.dateID && errors.dateID}
                                        InputProps={{
                                            startAdornment: <InputAdornment position="start"></InputAdornment>
                                        }}
                                    >
                                    </TextField>
                                    <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                        <Button
                                            type="button"
                                            color='error'
                                            variant="outlined"
                                            onClick={() => clearAll()}
                                        > Clear</Button>
                                        <Button
                                            type="submit"
                                            color='secondary'
                                            variant="outlined"
                                        >Search</Button>
                                    </Stack>
                                </Stack>
                            </Stack>
                        </Form>
                    </FormikProvider>
                    <br />
                    {tableData.length == 0 ?
                        <SearchNotFound searchQuery="Customer Order Panel" />
                        :
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                            <Card style={{ justifycontent: 'center', width: '85rem' }} >
                                <TableContainer component={Paper} >
                                    <Table size='small' aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell align="left">Outlet</TableCell>
                                                <TableCell align="left">Order No</TableCell>
                                                <TableCell align="right">Recipe Products Count</TableCell>
                                                <TableCell align="right">Fresh Products Count</TableCell>
                                                <TableCell align="right">Fresh Cut Products Count</TableCell>
                                                <TableCell align="center">Action</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {(rowsPerPage > 0
                                                ? tableData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                : tableData
                                            ).map((row) => (
                                                <TableRow key={row.specialOrderID}>
                                                    <TableCell align="left">
                                                        {row.factoryName}
                                                    </TableCell>
                                                    <TableCell align="left" >
                                                        {row.orderNo}
                                                    </TableCell>
                                                    <TableCell align="right" >
                                                        {row.batchCount}
                                                    </TableCell>
                                                    <TableCell align="right">
                                                        {row.freshSkuCount}
                                                    </TableCell>
                                                    <TableCell align="right">
                                                        {row.freshCutSkuCount}
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <Tooltip title="Edit Customer Order">
                                                            <IconButton aria-label="delete" onClick={() => handleClick(row)}>
                                                                <EditIcon />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                            {emptyRows > 0 && (
                                                <TableRow style={{ height: 53 * emptyRows }}>
                                                    <TableCell colSpan={8} />
                                                </TableRow>
                                            )}
                                        </TableBody>
                                        <TableFooter>
                                            <TableRow>
                                                <TablePagination
                                                    rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                                                    colSpan={8}
                                                    count={tableData.length}
                                                    rowsPerPage={rowsPerPage}
                                                    page={page}
                                                    SelectProps={{
                                                        inputProps: {
                                                            'aria-label': 'rows per page',
                                                        },
                                                        native: true,
                                                    }}
                                                    onPageChange={handleChangePage}
                                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                                    onSpecialOrderCreated={handleSpecialOrderCreated}
                                                    ActionsComponent={TablePaginationActions}
                                                />
                                            </TableRow>
                                        </TableFooter>
                                    </Table>
                                </TableContainer>
                            </Card>
                        </Stack>
                    }
                </Container>
                <div hidden={true}>
                    <Grid item>
                        <AlertDialog confirmData={confirmData} headerMessage={message} viewPopup={EnableConfirmMessage}
                            discription={"Are you sure want to approve this Special Order ?"} setViewPopup={setEnableConfirmMessage} />
                    </Grid>
                </div>
                <div hidden={true}>
                    <Grid item>
                        <AlertDialog confirmData={confirmData2} headerMessage={message2} viewPopup={EnableConfirmMessage2}
                            discription={"Are you sure want to reject this Special Order ?"} setViewPopup={setEnableConfirmMessage2} />
                    </Grid>
                </div>
            </Page>
        </>
    );
}